<template>
  <div :class="rootClassnames" v-if="text">
    <Popup @openchange="handlePopupOpenChange" :openOn="'hover'">
      <template slot="control">
        <InteractiveSvgIcon :isActive="isPopupOpen">
          <template v-if="darkIcon">
            <SvgIconHelp v-if="!isPopupOpen" />
            <SvgIconHelp v-else :backgroundColor="'#cacaca'" />
          </template>
          <template v-else>
            <SvgIconHelp v-if="!isPopupOpen" :backgroundColor="'#cacaca'" />
            <SvgIconHelp v-else />
          </template>
        </InteractiveSvgIcon>
      </template>

      <template slot="content">
        <p :class="'tooltip__text'">{{ text }}</p>
      </template>
    </Popup>
  </div>
</template>

<script>
  import InteractiveSvgIcon from '@/components/InteractiveSvgIcon'
  import Popup from '@/components/Popup/Popup'

  import SvgIconHelp from '@/svgs/SvgIconHelp'

  export default {
    name: 'ToolTip',
    components: {
      InteractiveSvgIcon,
      Popup,
      SvgIconHelp
    },
    props: {
      darkIcon: Boolean,
      text: String
    },
    data: function () {
      return {
        isPopupOpen: false
      }
    },
    computed: {
      rootClassnames: function () {
        const classname = 'tooltip'
        const isPopupOpen = this.isPopupOpen && `${classname}--popup-open`

        return [
          classname,
          isPopupOpen
        ]
      }
    },
    methods: {
      handlePopupOpenChange: function (isPopupOpen) {
        this.isPopupOpen = isPopupOpen
      }
    }
  }
</script>

<style lang="scss">
@import '../../scss/abstracts/__dir';
@import '../../scss/global/__dir';

$ns: '.tooltip';

#{$ns} {
  position: relative;

  &__text {
    color: #fff;
    display: block;
    font-family: $font-primary-medium;
    font-size: 12px;
    line-height: 12px;
    padding: 11px 10px;
    white-space: nowrap;
  }

  .popup-area {
    bottom: 100%;
    left: 50%;
    padding-bottom: 8px;
    padding-top: 0;
    transform: translate3d(-50%,0,0);
    z-index: 30;
  }

  .popup-content {
    background-color: color('black');
    border-radius: 3px;
    position: relative;

    //
    // decorative "tail" that appears at the top of the box
    //
    &:before {
      border: 8px solid color('black');
      border-left-color: transparent;
      border-right-color: transparent;
      border-top-color: transparent;
      content: '';
      display: block;
      height: 16px;
      position: absolute;
      right: auto;
      left: 50%;
      top: auto;
      bottom: 0;
      transform: translate3d(-50%,calc(100% - 4px),0) rotate(180deg);
      width: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/js/components/ToolTip.vue